export default __webpack_public_path__ + "static/media/twitter.254161b6.png";